export const filterRepoItems = ({
  items,
  repoView,
  currentFolder,
  searchTerm,
  dayFilter,
  typeFilters,
  appliedSortOrder,
  appliedFolderSort,
}) => {
  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  const viewFiltered = items.filter((item) => {
    if (repoView === "global") {
      return (
        item.ownerType === "admin" ||
        item.mode === "global" ||
        item.mode === "group"
      );
    }
    if (repoView === "personal") {
      return (
        item.ownerType !== "admin" &&
        item.mode !== "global" &&
        item.mode !== "group"
      );
    }
    if (repoView === "personal_space") {
      return item.isPersonalSpace === true;
    }
    return true;
  });

  let result = viewFiltered.filter((item) => {
    if (!normalizedSearchTerm && item.parentId !== currentFolder) return false;

    if (
      normalizedSearchTerm &&
      !item.name.toLowerCase().includes(normalizedSearchTerm)
    ) {
      return false;
    }

    if (dayFilter && dayFilter !== "All") {
      const itemDate = new Date(item.updatedAt || item.createdAt);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (dayFilter === "Today") {
        if (itemDate < today) return false;
      } else if (dayFilter === "Yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        if (itemDate < yesterday || itemDate >= today) return false;
      } else if (dayFilter === "Last 7 Days") {
        const weekAgo = new Date(today);
        weekAgo.setDate(today.getDate() - 7);
        if (itemDate < weekAgo) return false;
      }
    }

    if (!typeFilters.includes("all")) {
      // Always keep folders visible
      if (item.type === "folder") return true;

      const fileName = (item.name || "").toLowerCase();
      const fileExt = (
        item.fileExtension ||
        fileName.split(".").pop() ||
        ""
      ).toLowerCase();
      const itemType = (item.fileType || "").toLowerCase();

      const isDoc =
        /\.(pdf|doc|docx|txt|rtf|odt|xls|xlsx|ppt|pptx)$/.test(fileName) ||
        itemType.includes("application/") ||
        itemType.includes("document") ||
        itemType.includes("text") ||
        [
          "pdf",
          "doc",
          "docx",
          "txt",
          "rtf",
          "odt",
          "xls",
          "xlsx",
          "ppt",
          "pptx",
        ].includes(fileExt);

      const isVideo =
        /\.(mp4|mkv|avi|mov|wmv|flv)$/.test(fileName) ||
        itemType.includes("video") ||
        itemType.includes("youtube") ||
        fileExt === "youtube" ||
        fileName.includes("youtube.com") ||
        fileName.includes("youtu.be");

      const isUrl =
        (itemType === "webpage" ||
          fileExt === "webpage" ||
          fileName.startsWith("http")) &&
        !fileName.includes("youtube.com") &&
        !fileName.includes("youtu.be") &&
        fileExt !== "youtube";

      const isText = itemType === "text";
      const isQa = itemType === "qa";

      let matches = false;
      if (typeFilters.includes("document") && isDoc) matches = true;
      if (typeFilters.includes("video") && isVideo) matches = true;
      if (typeFilters.includes("url") && isUrl) matches = true;
      if (typeFilters.includes("text") && isText) matches = true;
      if (typeFilters.includes("qa") && isQa) matches = true;

      if (!matches) return false;
    }

    return true;
  });

  result.sort((a, b) => {
    if (appliedFolderSort === "Top") {
      if (a.type === "folder" && b.type !== "folder") return -1;
      if (a.type !== "folder" && b.type === "folder") return 1;
    }
    const dateA = new Date(a.updatedAt || a.createdAt).getTime();
    const dateB = new Date(b.updatedAt || b.createdAt).getTime();
    if (appliedSortOrder === "Ascending") {
      return dateA - dateB;
    }
    return dateB - dateA;
  });

  return result;
};
